var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.lstDiagnostico),function(item){return _c('v-col',{key:item.software.id,attrs:{"cols":"6","sm":"3","md":"3"},on:{"click":function($event){return _vm.redirectTo(item.software.id)}}},[_c('lista-software-card-lista-software',{attrs:{"icone":item.software.icone,"qtdAulas":item.software.aulas.length}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }